<script>
import OrderStopsRouteDialog from "@/views/orders/components/OrderStopsRouteDialog.vue";
import OmniDialog from "@/components/omni/OmniDialog.vue";
import AttachTruckDialog from "@/views/trips/edit/components/dialogs/AttachTruckDialog.vue";
import GoogleMapsMixin from "@/mixins/google-maps.mixin.ts";
import OrderSidebarTravelOrder from "@/views/orders/view/components/OrderSidebarTravelOrder.vue";

export default {
  name: "OrderViewSidebar",
  components: {
    OrderSidebarTravelOrder,
    AttachTruckDialog,
    OmniDialog,
    OrderStopsRouteDialog,
  },
  mixins: [GoogleMapsMixin],
  props: {
    order: Object,
  },
  data() {
    return {
      attachTruckDialog: false,
      showRoute: false,
    };
  },
  computed: {
    travelOrders() {
      if (!this.order.trip || !this.order.trip.routes) return [];

      const travelOrders = [];
      for (const route of this.order.trip.routes) {
        for (const travelOrder of route.travelOrders) {
          // skip travel orders for other orders
          if (travelOrder.orderId !== this.order.id) continue;
          travelOrders.push(travelOrder);
        }
      }

      return travelOrders;
    },
  },
  methods: {
    attachToOrder(truck) {
      this.$router.push({
        name: "trip-edit",
        params: { id: "new" },
        query: { order: this.order.id, truck: truck?.id },
      });
    },
  },
};
</script>

<template>
  <div class="flex-1 pa-5">
    <div class="text-grey-darken-3 mb-8 font-weight-medium text-subtitle-1">Information</div>
    <div v-if="order.tripId" class="mb-3">
      <div class="d-flex block align-center flex-wrap mb-2">
        <span class="font-weight-medium text--lighten-1 mr-4" data-qa="trip">
          Trip:
          <router-link
            :to="{ name: 'trip-view', params: { id: order.tripId } }"
            class="text-decoration-none text-primary"
            target="_blank"
          >
            #{{ order.tripId }}
          </router-link>
        </span>
      </div>
    </div>
    <div v-for="travelOrder in travelOrders" :key="travelOrder.id" class="mb-3 block">
      <order-sidebar-travel-order :order="order" :routes="order.trip.routes" :travel-order="travelOrder" />
    </div>
    <div class="order-actions">
      <v-btn
        class="mt-3 text-uppercase font-weight-600 width-100"
        color="primary"
        variant="outlined"
        @click="showRoute = true"
      >
        View route
      </v-btn>
      <v-btn
        v-if="!order.tripId"
        class="mt-3 text-uppercase font-weight-600 width-100"
        color="primary"
        variant="outlined"
        @click="attachTruckDialog = true"
      >
        Attach Truck
      </v-btn>
    </div>
    <order-stops-route-dialog v-if="showRoute" v-model="showRoute" :order="order"></order-stops-route-dialog>
    <omni-dialog
      v-model="attachTruckDialog"
      size="large"
      title="Attach truck/carrier"
      @close="attachTruckDialog = false"
    >
      <attach-truck-dialog @attach="attachToOrder" />
    </omni-dialog>
  </div>
</template>

<style lang="scss" scoped>
.block {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 16px;
  margin-bottom: 16px;
}
</style>
